// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3196":"04daea91","5998":"04daea91","6889":"17d7ff41"}[chunkId] + ".chunk.css";
};